'use strict';

if (process.env.NODE_ENV === "production") {
  module.exports = require("./xsite-ui-common.report.cjs.prod.js");
} else {
  module.exports = require("./xsite-ui-common.report.cjs.dev.js");
}
